import { NotificationProps as RaNotificationProps } from 'react-admin';

import { NotificationContent } from './NotificationContent';
import { NotificationStyled } from './NotificationStyled.styled';

export const Notification = () => <NotificationStyled slots={{ content: NotificationContent }} />;

export type NotificationProps = RaNotificationProps;
